var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"guide-entry"},[_c('i',{staticClass:"iconfont icon-info"}),_vm._v(" "),_c('p',{staticClass:"entry-text"},[_vm._v("寺库优惠券"),_c('router-link',{staticClass:"entry-link",attrs:{"to":"/v1/ucticketList/operatingGuide"}},[_vm._v("使用指南")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d22ca612","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/TicketList/components/GuideEntry.vue
// module id = null
// module chunks = 